module.exports = __webpack_public_path__ + "static/jfokus-6c8e23e0551b54030d604fe78aef0466.png";